import { FunctionComponent } from "react";

export const SixtLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/sixt.svg"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="Sixt"
    />
  );
};
